module.exports = __webpack_public_path__ + "media/images/vp/icon.syncing-f7d4c67772e0d5c50766071cb25bd1e9.png";